/**
 * <AuthHeading> — le titre d'un écran d'avant connexion, et sa phrase (molecule).
 *
 * Tous ces écrans s'ouvrent de la même façon : un titre centré en 800 (le titre du livre), annoncé
 * comme tel, et au plus une phrase grise dessous. Une seule pièce, pour que le titre ait partout le même rôle et la phrase
 * la même encre.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Title } from "../../atoms/typography/Title"

export type AuthHeadingProps = {
    title: string
    /** La phrase sous le titre — du texte, où un `<Text weight="bold">` peut souligner un nom. */
    children?: React.ReactNode
    testID?: string
}

export function AuthHeading(props: AuthHeadingProps) {
    const { title, children, testID } = props

    return (
        <Stack gap="2" align="center" testID={testID}>
            <Title center weight="extrabold" accessibilityRole="header">
                {title}
            </Title>
            {children != null && (
                <Text color="text-muted" center>
                    {children}
                </Text>
            )}
        </Stack>
    )
}
